Drupal.behaviors.header = {
  scrollToReveal() {
    return {
      ontop: true,
      sticky: false,
      lastPos: window.scrollY + 0,
      scroll() {
        this.ontop = window.scrollY < this.$refs.navbar.offsetHeight;
        this.sticky = window.scrollY > this.$refs.navbar.offsetHeight && this.lastPos > window.scrollY;
        this.lastPos = window.scrollY;
      }
    }
  },

  attach() {
  },
};
